import { render, staticRenderFns } from "./exchange-order-details.vue?vue&type=template&id=8de361ba&scoped=true&"
import script from "./exchange-order-details.vue?vue&type=script&lang=js&"
export * from "./exchange-order-details.vue?vue&type=script&lang=js&"
import style0 from "./exchange-order-details.vue?vue&type=style&index=0&id=8de361ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8de361ba",
  null
  
)

export default component.exports